import { useTranslation } from 'libs/i18n'
import CurrencyFormat from 'react-currency-format'

import type { CurrencyProps } from './types'

export const Currency = ({ price, className }: CurrencyProps) => {
	if (price.currency === 'ISK' || price.currency === 'SEK' || price.currency == 'DKK')
		return (
			<CurrencyFormat
				className={className}
				value={price.amount}
				displayType={'text'}
				thousandSeparator={'.'}
				decimalSeparator={','}
				suffix={' kr.'}
			/>
		)

	const { i18n } = useTranslation()
	const { language } = i18n

	return (
		<span className={className}>
			{price?.currency &&
				new Intl.NumberFormat(language, {
					style: 'currency',
					currency: price?.currency,
					minimumFractionDigits: 0
				}).format(price.amount)}
		</span>
	)
}
